module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/index.js
// module id = 257
// module chunks = 57